// extracted by mini-css-extract-plugin
export default {"login-form":"FormLogin_login-form__WMzt9","form":"FormLogin_form__rQqTZ","submit":"FormLogin_submit__xkTUF"};